import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPoint = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "pet__path-1-inside-1_17749_3366",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", {
				fill: props.color,
				d: "M9.79187 2.50015C13.9338 2.50025 17.2919 5.85816 17.2919 10.0002C17.2918 14.1421 13.9338 17.5001 9.79187 17.5002C5.64986 17.5002 2.29195 14.1421 2.29187 10.0002C2.29187 5.8581 5.64982 2.50015 9.79187 2.50015Z"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: props.color,
			d: "M9.79187 2.50015L9.79189 1.60017H9.79187V2.50015ZM17.2919 10.0002L18.1919 10.0002V10.0002H17.2919ZM9.79187 17.5002V18.4001H9.79189L9.79187 17.5002ZM2.29187 10.0002H1.39189V10.0002L2.29187 10.0002ZM9.79187 2.50015L9.79185 3.40013C13.4368 3.40022 16.3919 6.35523 16.3919 10.0002H17.2919H18.1919C18.1919 5.36109 14.4309 1.60028 9.79189 1.60017L9.79187 2.50015ZM17.2919 10.0002L16.3919 10.0001C16.3918 13.645 13.4367 16.6001 9.79185 16.6002L9.79187 17.5002L9.79189 18.4001C14.4308 18.4 18.1917 14.6391 18.1919 10.0002L17.2919 10.0002ZM9.79187 17.5002V16.6002C6.14693 16.6002 3.19192 13.6451 3.19185 10.0001L2.29187 10.0002L1.39189 10.0002C1.39198 14.6392 5.1528 18.4001 9.79187 18.4001V17.5002ZM2.29187 10.0002H3.19185C3.19185 6.35514 6.14686 3.40013 9.79187 3.40013V2.50015V1.60017C5.15277 1.60017 1.39189 5.36105 1.39189 10.0002H2.29187Z",
			mask: "url(#pet__path-1-inside-1_17749_3366)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: props.color,
			d: "M10.323 6.25006C12.1699 6.25023 12.7292 7.35868 12.7292 8.5069C12.7292 10.2443 11.7804 11.1436 9.90308 11.1436H9.11401V13.4796H7.58667V6.25006H10.323ZM9.11401 7.48834V9.90533H9.73413C9.75805 9.90532 9.78181 9.90383 9.80542 9.90338C10.5602 9.88917 11.1511 9.64231 11.1511 8.61627C11.1509 7.68801 10.6021 7.48834 9.85327 7.48834H9.11401Z"
		})
	]
});
const ForwardRef = forwardRef(SvgPoint);
export default ForwardRef;
